export default __webpack_public_path__ + "static/media/rating-1.cdd8ae90.webp";